import _objectWithoutProperties from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["onChange"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import { DropzoneArea } from 'material-ui-dropzone';
const FileUploader = _ref => {
  let {
      onChange
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(DropzoneArea, _extends({}, rest, {
    onChange: onChange
  }));
};
export default FileUploader;